<template lang="html">
   <spinner v-bind:busy="busy"></spinner>
</template>

<script>
var pdfMake = require('pdfmake/build/pdfmake.js');
var pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import apiclient from '@/apiclient.js'
import spinner from './spinner.vue'
import numeral from 'numeral'

export default {
  name: 'fatture',
  components: {
    spinner
  },
  props: {
      campagne: Array, // filtro campagne booleano
      codicecliente: String,
      nascondilinee: Boolean
  },
  data() {
    return {
      campagnestampate: '',
      tipovalore: "quantità",
      tipodato: "ordinato",
      docDefinition: {},
      campagna:0,
      busy: false,

      records:[],
      cols:[],
      rows:[],
      linee:[],

      filteredCol: -1,
      filteredRow: -1,

      fieldsstring: '',
      filterPanel: {
        show: false,
        value:'',
        name:'',
        index:0,
        filterCol: {}
      }
    }
  },
  computed: {
    actualdealer: function() {
      if (this.$store.state.multizona) 
        return this.$store.getters.zona;
      else
        return '';
    }
  },
  watch: {
    actualdealer: function() {
      this.getRecords();
    }
  },
  created: function() {
  },
  mounted: function() {
    if (!this.campagna) this.campagna=this.$store.state.campagne[0];
    var self=this;
    this.getLinee().then(function() {
      self.getRecords();
    })
  },
  methods: {    

    gotoRecord: function(record) {
      console.log('gotoRecord'+record.Id);
      this.$router.push({ name:'CustomerForm', params: { id: record.Id, record: record } });
    },
    changeDato: function() {
      console.log(this.tipodato);
      this.filteredCol=-1;
      this.getRecords();
    },
    changeValore: function() {
      console.log(this.tipovalore);
      this.getCols();      
    },
    changeCampagna: function(index) {
      console.log('changeCampagna');
      console.log(index);
      this.campagna=this.$store.state.campagne[index];
      this.getRecords();
    },
    filterCol: function(index) {
      console.log('filter:'+index);
      if (this.filteredCol<0) {
        this.filteredCol=index;
      } else {
        this.filteredCol=-1;
      }
      this.getCols();      
    },
    filterRow: function(index) {
      console.log('filter:'+index);
      if (this.filteredRow<0) {
        this.filteredRow=index;
      } else {
        this.filteredRow=-1;
      }
      this.getCols();      
    },
    getLinee: function() {
      var self=this;
      return new Promise(function(resolve, reject) {
        var soql='select Name, Descrizione__c from Linea__c ';

        console.log(soql);
        self.busy=true;
        apiclient.query(self.$store.getters.connection, soql).then(function(data) {
          console.log('records:'+data.length);
          self.linee=data;
          self.busy=false;
          resolve();
        }).catch(function(err){
          console.log(err);
          reject();
        })
      });
    },
    openPdf: function() {
      console.log(this.docDefinition);
      var mypdf=pdfMake.createPdf(this.docDefinition)
      mypdf.download('FCP_Mastrini.pdf');
      this.$emit('change');
    },
    injectTotals: function(l, levelRecord, levelContent) {
        var lc=this.docDefinition.content[ levelContent[l] ];
        lc.table.body[0][3].text=numeral(levelRecord[l].Importo).format('$ 0,0.00');
        lc.table.body[0][4].text=levelRecord[l].Quantita_Venduta;
        lc.table.body[0][5].text=levelRecord[l].Quantita_Omaggio;
        lc.table.body[0][6].text=levelRecord[l].Quantita_Rese;
        lc.table.body[0][7].text=levelRecord[l].Quantita_Totale;
        lc.table.body[0][8].text=numeral(levelRecord[l].Sconto).format('0.0');
    },
    getCols: function() {
      this.cols.splice(0,this.cols.length);
      this.rows.splice(0,this.rows.length);

      console.log('inizio getcol');
      console.log(new Date());

      var campagnestampate=this.campagnestampate;
      this.docDefinition = {
        defaultFileName: 'FCP_Mastrini.pdf',
        info: {
          title: 'Mastrini Campagna '+campagnestampate,
          author: 'Franco Cosimo Panini Editore S.p.A.',
        },
          pageSize: 'A4',
          pageMargins: [20, 50, 30, 40],
          content: [],
          header: function() { 
           return [
          {text: "Franco Cosimo Panini Editore S.p.A.- Sede legale: Via Giardini, 474/D - 41124 MODENA (MO)", alignment: 'center', fontSize: 6, margin: [2, 29, 2, 2]},
          {text: "Divisione scuola: VIA LIGURIA 12/14 - 40064 OZZANO EMILIA (BO) IT", alignment: 'center', fontSize: 6, margin: [2, 1, 6, 2]}
           ];
          },
          footer: function(currentPage, pageCount) { 
           return [
            {text: "Mastrini campagna "+campagnestampate+' '+' '+' '+' '+' '+' '+' '+' '+' '+' '+' '+' '+' '+' '+' '+' '+' '+' '+' '+' '+' '+' '+' '+' '+' '+' '+' '+' '+' '+ currentPage.toString() + ' / ' + pageCount, alignment: 'right', fontSize: 8, margin: [8, 6, 30, 6] }

           ]
           },
          styles: {
            cssPrimaRiga: { fontSize: 14, bold: true, color: 'black', margin: [ 0, 12, 0, 0 ] },            
            header: { fontSize: 12, bold: true, color: 'black', margin: [2, 2, 4, 4] },
            tableHeader: { fontSize: 9, color: 'white', fillColor: '#932036' },
            HeaderGrigia: { fontSize: 9, color: 'black'},
            HeaderLinea: { fontSize: 9, color: 'black' },
            HeaderBianco: { fontSize: 8, color: '#932036', margin: [0, 16, 0, 0]},
            cssCorpo: { fontSize: 8, color: 'black', fillColor: 'white' }
          }
      };

      pdfMake.tableLayouts = {
        noBordi: {
          hLineWidth: function () { return 0; },
          vLineWidth: function () { return 0; },
          paddingLeft: function () { return 6; },
          paddingRight: function () { return 0; },
          paddingTop: function () { return 2; },
          paddingBottom: function () { return 2; },
        },
        tableCorpo: {
          hLineWidth: function (i,node) { return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1; },
          vLineWidth: function (i,node) { return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;},
          paddingLeft: function () { return 4; },
          paddingRight: function () { return 2; },
          paddingTop: function () { return 2; },
          paddingBottom: function () { return 2; },
          hLineColor: function(i, node) { return (i === 0 || i === node.table.body.length) ? 'grey' : 'grey';},
          vLineColor: function(i, node) {return (i === 0 || i === node.table.widths.length) ? 'grey' : 'grey';},
        }
      } ;
        
      // pdfMake.createPdf(docDefinition).open();

      var ord=0;
      this.cols.push( { order: ord++, value:'', label:'PV', name:'COUNTY', type:'string' } );
      this.cols.push( { order: ord++, value:'', label:'Città', name:'CITY', type:'string' } );
      this.cols.push( { order: ord++, value:'', label:'Cap', name:'ZIPCODE', type:'string' } );
      this.cols.push( { order: ord++, value:'', label:'Cliente', name:'codice_nome', type:'string' } );
      this.cols.push( { order: ord++, value:'', label:'Camp.', name:'FCP_COPYCMSCAMPAIGNID', type:'string' } );
      this.cols.push( { order: ord++, value:'', label:'Linea', name:'linea', type:'string' } );
      this.cols.push( { order: ord++, value:'', label:'Codice', name:'itemid', type:'string' } );
      this.cols.push( { order: ord++, value:'', label:'Descrizione', name:'descrizione_articolo', type:'string' } );
      this.cols.push( { order: ord++, value:'', label:'Totale', name:'Importo', type:'currency' } );
      this.cols.push( { order: ord++, value:'', label:'Vend.', name:'Quantita_Venduta', type:'decimal' } );
      this.cols.push( { order: ord++, value:'', label:'Om.', name:'Quantita_Omaggio', type:'decimal' } );
      this.cols.push( { order: ord++, value:'', label:'Rese', name:'Quantita_Rese', type:'decimal' } );
      this.cols.push( { order: ord++, value:'', label:'Tot', name:'Quantita_Totale', type:'decimal' } );
      this.cols.push( { order: ord++, value:'', label:'Sc%', name:'Sconto', type:'decimal' } );

      var levelKey=[], levelRecord=[];
      var levelContent=[0,0,0,0];
      var levelField= [ 'COUNTY','CITY','ZIPCODE','codice_nome','FCP_COPYCMSCAMPAIGNID', 'linea'];

      this.records.forEach(function(r) {
        // C'è il limit di 500, va tolto quando è finito
       //if (index<600){
        r.Quantita_Totale=r.Quantita_Venduta+r.Quantita_Omaggio-r.Quantita_Rese;
            
        levelField.forEach(function(f,i) {
          
          if (levelKey[i]!=r[f]) {
            var nr={ nRecord:0, sommaSconto:0, Importo:0, isbold:i<=4, Id:r.custaccount, Quantita_Venduta:0, Quantita_Omaggio:0, Quantita_Rese:0,  Quantita_Totale:0, Sconto:0 };
            nr[f]=r[f];
            levelRecord[i]=nr;    
            for (var j=i;j>=0;j--)        
              nr[ levelField[j] ]=r[ levelField[j] ];
            
            levelKey[i]=r[f];
            for (var j2=i+1;j2<levelKey.length;j2++)        
              levelKey[j2]='';

            if (i==2) { // cambio cap
              this.docDefinition.content.push( this.makeH1(levelKey[0],levelKey[1],levelKey[2]) );
            }
            if (i==3) { // cambio cliente
              this.docDefinition.content.push( this.makeH2() );
              var t= this.makeTable() ;
              //console.log(t);
              var c=this.makeCustomer( levelKey[3]);
              t.table.body.push( c );
             
              this.docDefinition.content.push(t);
              levelContent[i]=this.docDefinition.content.length-1;
            }
            if (i==4) { //Rottura x campagna
              var t1= this.makeTable() ;
              var nisba=this.makeIntermezzo(levelKey[4]); 
              t1.table.body.push( nisba );              
              this.docDefinition.content.push(t1);
              levelContent[i]=this.docDefinition.content.length-1;
            }   
             if (i==5 && !this.nascondilinee) { //Rottura x linea
              var t2= this.makeTable() ;
              var desclinea=this.linee.find(function(v) { return v.Name==r.linea; });
              var descrizione=(desclinea?desclinea.Descrizione__c:'');
              var nisba2=this.makeLinea(levelKey[5]+' '+descrizione); 
              t2.table.body.push( nisba2 );
              this.docDefinition.content.push(t2);
              levelContent[i]=this.docDefinition.content.length-1;
            }       
          }

          levelRecord[i].nRecord+=1;
          levelRecord[i].Importo+=r.Importo;
          levelRecord[i].Quantita_Venduta+=r.Quantita_Venduta;
          levelRecord[i].Quantita_Omaggio+=r.Quantita_Omaggio;
          levelRecord[i].Quantita_Rese+=r.Quantita_Rese;
          levelRecord[i].Quantita_Totale=levelRecord[i].Quantita_Venduta+levelRecord[i].Quantita_Omaggio-levelRecord[i].Quantita_Rese;
          if (r.Quantita_Totale) {
            levelRecord[i].sommaSconto+=r.Sconto/100*r.Importo;
            if (levelRecord[i].Quantita_Totale!=0)
              levelRecord[i].Sconto=levelRecord[i].sommaSconto/levelRecord[i].Importo*100;
          }
    
        },this);

        // inietta i totali dove serve
        this.injectTotals(3, levelRecord, levelContent);
        this.injectTotals(4, levelRecord, levelContent);
        if (!this.nascondilinee)
          this.injectTotals(5, levelRecord, levelContent);

        r.FCP_COPYCMSCAMPAIGNID='';
        r.Id=r.custaccount;

        if (!this.nascondilinee) {
          var t=this.docDefinition.content[this.docDefinition.content.length-1];
          t.table.body.push( this.makeData(  r.itemid,r.descrizione_articolo, r.linea, numeral(r.Importo).format('0,0.00'), r.Quantita_Venduta, r.Quantita_Omaggio, r.Quantita_Rese, r.Quantita_Totale, numeral(r.Sconto).format('0.0')) );
        }
       //}
      }, this)
      

      if (this.filteredRow>=0) {
        console.log('trim rows:'+this.filteredRow)
        this.rows.splice(this.filteredRow+1, this.rows.length)
        this.rows.splice(0, this.filteredRow)
      }

      console.log('fine getcol');
      console.log(new Date());

    },
    getRecords: function() {
      console.log('campagna')
      console.log(this.campagna)
      var anno_cc=this.campagna.substr(0,4);
      var cc=this.campagna.substr(5,2);

      console.log(anno_cc)
      console.log(cc)

      var self=this;
      var sql='';

      // es: "2021 SC"
      var filtrocampagne=[];
      var nomicampagne=[];
      this.campagne.forEach(function(f,i) {
        if (f) {
          var wc=this.$store.state.campagne[i];
          this.nomicampagne+=wc+' ';
          var w="( righe.FCP_COPYCMSYEAR="+wc.substr(0,4)+" and righe.FCP_COPYCMSCAMPAIGNID='"+wc.substr(5,2)+"' )";
          filtrocampagne.push(w);
          nomicampagne.push(wc);
        }
      }, this);
      var wcampagne=filtrocampagne.join(' OR ');
      if (wcampagne>'') wcampagne='( '+wcampagne+' ) AND ';
      this.campagnestampate=nomicampagne.join(',');

sql="select clienti.COUNTY, clienti.CITY, clienti.ZIPCODE, ";
sql+="righe.FCP_COPYCMSYEAR, righe.FCP_COPYCMSCAMPAIGNID, ordini.CUSTACCOUNT as custaccount, clienti.NAME as nome_cliente, concat(ordini.CUSTACCOUNT, ' - ',clienti.NAME) as codice_nome, prodotti.FCP_ITEMPRODUCTLINEID as linea, ";
sql+="righe.itemid, righe.name as descrizione_articolo, sum(righe.QTYORDERED) Quantita, ";
sql+="sum( case when GOODSFORFREE=0 and righe.QTYORDERED>=0 then righe.QTYORDERED else 0 end ) as Quantita_Venduta, ";
sql+="sum( case GOODSFORFREE when 0 then 0 when 1 then righe.QTYORDERED end ) as Quantita_Omaggio, ";
sql+="sum( case when righe.QTYORDERED>=0 then 0 when righe.QTYORDERED<0 then SAFE_NEGATE(righe.QTYORDERED) end ) as Quantita_Rese, ";
sql+="sum(LINEAMOUNT) as Importo, avg(DISCPERCENT) as Sconto ";
sql+="from ax.SALESLINE righe left join ax.SALESTABLE ordini on (ordini.salesid=righe.salesid) ";
sql+="left join ax.CUSTTABLE clienti on (UPPER(ordini.CUSTACCOUNT)=UPPER(clienti.ACCOUNTNUM) ) ";
sql+="left join ax.INVENTTABLE as prodotti on (righe.itemid=prodotti.itemid) ";
sql+="where "+wcampagne;
if (this.codicecliente)   sql+="  UPPER(ordini.CUSTACCOUNT)='"+this.codicecliente+"' AND ";
sql+=" clienti.zona1 like '"+this.$store.getters.zona+"' ";
// sql+=" ordini.ZONE1 like '"+this.$store.getters.zona+"' ";
sql+=" and righe.SALESSTATUS!=4 and ordini.SALESSTATUS!=4 ";
sql+="group by clienti.ZIPCODE, clienti.CITY, clienti.COUNTY, righe.FCP_COPYCMSYEAR,  ordini.CUSTACCOUNT, clienti.NAME, righe.FCP_COPYCMSCAMPAIGNID, prodotti.FCP_ITEMPRODUCTLINEID, righe.itemid, righe.name ";
sql+="order by clienti.ZIPCODE, clienti.COUNTY, clienti.CITY, righe.FCP_COPYCMSYEAR,  ordini.CUSTACCOUNT, clienti.NAME, righe.FCP_COPYCMSCAMPAIGNID,prodotti.FCP_ITEMPRODUCTLINEID, righe.itemid, righe.name ";

      console.log(sql);
      console.log(new Date());
      this.busy=true;

      apiclient.getBQ(this.$store.getters.connection, sql)
        .then(function(records) {
          self.records=records;
          console.log(records.length);
          console.log(new Date());
          self.getCols();
          self.busy=false;
          self.openPdf();
      console.log('fine callback');
      console.log(new Date());

        });
    }, 
    
  
 
 makeH1: function(county, city, zipcode) {
    return {
        layout: 'headerLineOnly',
        table: {
            widths: ['auto', 'auto', 'auto'],
            headerRows: 1,
            body: [
                [{
                    text: county,
                    style: 'cssPrimaRiga',
                    alignment: 'center'
                }, {
                    text: city,
                    style: 'cssPrimaRiga',
                    alignment: 'center',
                }, {
                    text: zipcode,
                    style: 'cssPrimaRiga',
                    alignment: 'center'
                }  ],

            ]
        }
    }
},


 makeH2: function() 
{
    return {
        layout: 'noBordi',
        table: {
        widths: [200, 20, 30, 54, 40, 40, 40, 40, 30],            
        headerRows: 1,
            body: [
                [{ text: '', style: 'HeaderBianco', colSpan: 2 },
                 {}, 
                 { text: 'LINEA', style: 'HeaderBianco', alignment: 'left'},
                 { text: '€ TOTALE', style: 'HeaderBianco', alignment: 'center'}, 
                 { text: 'VEND', style: 'HeaderBianco', alignment: 'center'}, 
                 { text: 'OM', style: 'HeaderBianco', alignment: 'center'}, 
                 { text: 'RESE', style: 'HeaderBianco', alignment: 'center'},
                  { text: 'QTA TOT', style: 'HeaderBianco', alignment: 'center'}, 
                  { text: 'SC %', style: 'HeaderBianco', alignment: 'center'}
                  ],

            ]
        }
    }
},


 makeTable: function() {
   var tabella = { 
      layout: 'tableCorpo',
      table: {
             widths: [200, 20, 30, 54, 40, 40, 40, 40, 30],
            headerRows: 1,
            body: []
        }
    };
    return tabella;
   
},

 makeIntermezzo: function(FCP_COPYCMSCAMPAIGNID,linea, Importo, Quantita_Venduta, Quantita_Omaggio, Quantita_Rese, Quantita_Totale, Sconto) {
    var x=[
      { text: FCP_COPYCMSCAMPAIGNID, style: 'HeaderGrigia', colSpan: 2, alignment: 'right', bold: true }, 
      {}, 
      { text: '', style: 'HeaderGrigia', alignment: 'center' }, 
      { text: '€ 2300', style: 'HeaderGrigia', alignment: 'right', bold: true }, 
      { text: '129', style: 'HeaderGrigia', alignment: 'right', bold: true }, 
      { text: '4', style: 'HeaderGrigia', alignment: 'right', bold: true }, 
      { text: '0', style: 'HeaderGrigia', alignment: 'right', bold: true },
      { text: '133', style: 'HeaderGrigia', alignment: 'right', bold: true }, 
      { text: '18', style: 'HeaderGrigia', alignment: 'right' , bold: true}
    ]; 

    return x;    
},
makeLinea: function(FCP_COPYCMSCAMPAIGNID,linea, Importo, Quantita_Venduta, Quantita_Omaggio, Quantita_Rese, Quantita_Totale, Sconto) {
    var x=[
      { text: FCP_COPYCMSCAMPAIGNID, style: 'HeaderLinea', colSpan: 2, alignment: 'left', bold: true }, 
      {}, 
      { text: '', style: 'HeaderLinea', alignment: 'center' }, 
      { text: '€ 2300', style: 'HeaderLinea', alignment: 'right', bold: true }, 
      { text: '129', style: 'HeaderLinea', alignment: 'right', bold: true }, 
      { text: '4', style: 'HeaderLinea', alignment: 'right', bold: true }, 
      { text: '0', style: 'HeaderLinea', alignment: 'right', bold: true },
      { text: '133', style: 'HeaderLinea', alignment: 'right', bold: true }, 
      { text: '18', style: 'HeaderLinea', alignment: 'right' , bold: true}
    ]; 

    return x;    
},


 makeCustomer: function(codice_nome, FCP_COPYCMSCAMPAIGNID,linea, Importo, Quantita_Venduta, Quantita_Omaggio, Quantita_Rese, Quantita_Totale, Sconto) {
    var x=[
      { text: codice_nome, style: 'tableHeader', colSpan: 2, alignment: 'left', bold: true }, 
      {}, 
      { text: '', style: 'tableHeader', alignment: 'left' }, 
      { text: '€ 13200', style: 'tableHeader', alignment: 'right', bold: true }, 
      { text: '171', style: 'tableHeader', alignment: 'right', bold: true }, 
      { text: '20', style: 'tableHeader', alignment: 'right', bold: true }, 
      { text: '0', style: 'tableHeader', alignment: 'right', bold: true },
      { text: '191', style: 'tableHeader', alignment: 'right', bold: true }, 
      { text: '18', style: 'tableHeader', alignment: 'right', bold: true}
    ]; 

    return x;    
},

 makeData: function(itemid,descrizione_articolo,linea, Importo,  Quantita_Venduta, Quantita_Omaggio, Quantita_Rese, Quantita_Totale, Sconto) {
  var x=[
    { text: itemid+ ' - '+descrizione_articolo, style: 'cssCorpo', colSpan: 2, alignment: 'left' },
    {},
    { text: linea, style: 'cssCorpo', alignment: 'left' }, 
    { text: '€ ' +Importo, style: 'cssCorpo', alignment: 'right' }, 
    { text: Quantita_Venduta, style: 'cssCorpo', alignment: 'right' }, 
    { text: Quantita_Omaggio, style: 'cssCorpo', alignment: 'right' }, 
    { text: Quantita_Rese, style: 'cssCorpo', alignment: 'right' }, 
    { text: Quantita_Totale, style: 'cssCorpo', alignment: 'right' },
    { text: Sconto, style: 'cssCorpo', alignment: 'right' }
  ];


  return x;
}



  }
 
}

</script>

<style scoped>

testata {
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;
}

</style>